import { render, staticRenderFns } from "./StudyingAbroad.vue?vue&type=template&id=2b4bfa1e&scoped=true"
import script from "./StudyingAbroad.vue?vue&type=script&lang=js"
export * from "./StudyingAbroad.vue?vue&type=script&lang=js"
import style0 from "./StudyingAbroad.vue?vue&type=style&index=0&id=2b4bfa1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4bfa1e",
  null
  
)

export default component.exports